import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';

/**
 * ニュースセクション用Swiperの初期化
 * SP (1024px以下)のみ自動再生＋スワイプ可能
 *
 * @example
 * // .newsSwiper に適用
 */
const initNewsSwiper = (): void => {
    const el = document.querySelector('.newsSwiper');

    if (el && window.innerWidth <= 1024) {
        new Swiper('.newsSwiper', {
            modules: [Autoplay],
            slidesPerView: 'auto',
            spaceBetween: 0,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
        });
    }
};

const initNextSwiper = (): void => {
    const el = document.querySelector('.nextSwiper');

    new Swiper('.nextSwiper', {
        modules: [Autoplay],
        centeredSlides: true,
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
    });
};

/**
 * キャラクタースライダーの初期化
 * 自動スライドなし、ボタン操作のみでスライドする
 * 最初のスライドが中央に表示され、左右に前後のスライドが見える
 *
 * @example
 * // .charaSwiper に適用
 */
const initCharaSwiper = (): void => {
    const el = document.querySelector('.charaSwiper');

    if (!el) return;

    new Swiper('.charaSwiper', {
        modules: [Navigation],
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: true,
        speed: 500,
        centeredSlides: true,
        initialSlide: 0,
        navigation: {
            nextEl: '.chara__slideBtnsNext',
            prevEl: '.chara__slideBtnsPrev',
        },
    });
};

initNewsSwiper();
initNextSwiper();
initCharaSwiper();
